<template>
  <v-app>
    <header-comp />
    <v-main>
      <router-view />
    </v-main>
    <message></message>
  </v-app>
</template>

<script>
import header from "@/components/header-component.vue";
import axios from "axios";
import Message from "@/components/Message.vue";

export default {
  name: "App",
  components: {
    Message,
    "header-comp": header,
  },

  data: () => ({}),
  created() {
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function () {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logout");
        }
        throw err;
      });
    });
  },
  mounted() {},
};
</script>
